import { toast } from "../components/razor-reuse";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { CustomerState } from "./type";
import { generateQueryString } from "../helper/helpers";

export const getCustomers = createAsyncThunk(
  "web/get-customers",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/customer?page=${payload?.page || 1}${
          payload?.type ? `&type=${payload?.type}` : ``
        }&per_page=${payload?.per_page || "30"}${
          payload?.acc_status ? `&filter[status]=${payload?.acc_status}` : ``
        }${payload?.date ? `&filter[date]=${payload?.date}` : ``}${
          payload?.level_status
            ? `&filter[kyc_level]=${payload?.level_status}`
            : ``
        }${payload?.search ? `&search=${payload?.search}` : ``}${
          payload?.export ? `&export=${payload?.export}` : ``
        }`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        
        thunkAPI.dispatch(SET_CUSTOMERS(obj));
        // SET_CUSTOMERS(obj);
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getDeletedCustomers = createAsyncThunk(
  "web/get-deleted-customers",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/customer/deleted-accounts${generateQueryString({
          page: payload?.page || 1,
          per_page: payload?.per_page || 30,
          search: payload?.search,
          nationality: payload?.nationality,
        })}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        
        thunkAPI.dispatch(SET_DELETED_CUSTOMERS(obj));
        // SET_CUSTOMERS(obj);
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getDeletedCustomersExport = createAsyncThunk(
  "web/get-deleted-customers-export",
  async (payload: any, thunkAPI) => {
    try {
      toast.info("Download in progress...", {
        position: "top-right",
      });
      const exportFormat = payload?.export === "xlsx" ? "xlsx" : "csv";
      const data = await axios.get(
        `/admin/customer/deleted-accounts${generateQueryString({
          search: payload?.search,
          nationality: payload?.nationality,
          export: exportFormat,
        })}`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === 200) {
        const obj = data?.data;
        const url = window.URL.createObjectURL(new Blob([obj]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `deleted customers report.${exportFormat}`,
        );
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(url);
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getCustomersCsv = createAsyncThunk(
  "web/get-customers-export",
  async (payload: any, thunkAPI) => {
    try {
      toast.info("Download in progress...", {
        position: "top-right",
      });
      const data = await axios.get(
        `/admin/customer?page=${payload?.page || 1}${
          payload?.type ? `&type=${payload?.type}` : ``
        }&per_page=${payload?.per_page || "30"}${
          payload?.acc_status ? `&filter[status]=${payload?.acc_status}` : ``
        }${
          payload?.level_status
            ? `&filter[kyc_level]=${payload?.level_status}`
            : ``
        }${payload?.search ? `&search=${payload?.search}` : ``}&export=csv`,
      );

      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.status === 200) {
        const obj = data?.data;
        const url = window.URL.createObjectURL(new Blob([obj]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "customers report.csv");
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(url);
        return data;
      }
      return data;
    } catch (error: any) {
      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getCustomerSingle = createAsyncThunk(
  "web/get-customer-single",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/customer/${payload?.id || ""}`);
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        
        thunkAPI.dispatch(SET_CUSTOMER_SINGLE(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getCustomerSingleTransaction = createAsyncThunk(
  "web/get-customer-single-transaction",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/customer/transactions${generateQueryString(payload)}`,
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        
        thunkAPI.dispatch(SET_CUSTOMER_SINGLE_TRANSACTION(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getCustomerWallet = createAsyncThunk(
  "web/get-customer-wallet",
  async (id: any, thunkAPI) => {
    try {
      const data = await axios.get(`/admin/wallets/${id || ""}`);
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        
        thunkAPI.dispatch(SET_CUSTOMER_WALLET(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getCustomerSuspensionHistory = createAsyncThunk(
  "web/get-customer-suspension-history",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/customer/suspension-history/${payload?.id}${generateQueryString(
          payload,
        )}`,
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data;
        
        thunkAPI.dispatch(SET_CUSTOMER_SUSPENSION_HISTORY(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const suspendCustomer = createAsyncThunk(
  "web/suspend-customer",
  async (payload: { body: { reason: string }; id: string }, thunkAPI) => {
    try {
      const data = await axios.post(
        `/admin/suspend-user-account/${payload.id}`,
        payload.body,
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const unsuspendCustomer = createAsyncThunk(
  "web/unsuspend-customer",
  async (payload: { body: { reason: string }; id: string }, thunkAPI) => {
    try {
      const data = await axios.post(
        `/admin/unsuspended-customer-account/${payload.id}`,
        payload.body,
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const restoreCustomer = createAsyncThunk(
  "web/restore-customer",
  async (id: string, thunkAPI) => {
    try {
      const data = await axios.post(
        `/admin/customer/deleted-accounts/${id}/restore`,
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const approveCustomerKyc = createAsyncThunk(
  "web/approve-customer-kyc",
  async (payload: { body: { reason: string }; id: string }, thunkAPI) => {
    try {
      const data = await axios.post(
        `/admin/address-verification/approve/${payload.id}`,
        payload.body,
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const rejectCustomerKyc = createAsyncThunk(
  "web/reject-customer-kyc",
  async (payload: { body: { reason: string }; id: string }, thunkAPI) => {
    try {
      const data = await axios.post(
        `/admin/address-verification/reject/${payload.id}`,
        payload.body,
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const getCustomerAdditionalDoc = createAsyncThunk(
  "web/get-customer-additional-doc",
  async (payload: string, thunkAPI) => {
    try {
      const data = await axios.get(
        `/admin/address-verification/documents/${payload}`,
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        const obj = data?.data?.data;
        
        thunkAPI.dispatch(SET_CUSTOMER_ADDITIONAL_DOC(obj));
        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const addCommentToDocument = createAsyncThunk(
  "web/adding-comment-document",
  async (payload: { body: { comment: string }; id: string }, thunkAPI) => {
    try {
      const data = await axios.post(
        `/admin/address-verification/user-documents/add-comment`,
        { ...payload.body, document_id: payload.id },
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

export const uploadCustomerDocument = createAsyncThunk(
  "web/upload-customer-document",
  async (payload: any, thunkAPI) => {
    try {
      const data = await axios.post(
        `/admin/address-verification/upload-doc/${payload.id}`,
        payload.body,
      );
      if (data?.data?.status === "fail") {
        if (typeof data.data === "string") {
          toast.error(data.data);
        } else
          toast.error(data?.data?.message, {
            position: "top-right",
          });
        return thunkAPI.rejectWithValue(data);
      }
      if (data?.data?.status) {
        toast.success(data?.data?.message, {
          position: "top-right",
          theme: "colored",
        });

        return data;
      }
      return data;
    } catch (error: any) {
      console.log(error);

      if (error.message === "Network Error") {
        toast.error(error.message, {
          position: "top-right",
        });
      }
      if (
        error.response?.data?.status === "fail" &&
        error.response?.status !== 401
      ) {
        return thunkAPI.rejectWithValue(error);
      }
      return error;
    }
  },
);

const initialState: CustomerState = {
  loading: false,
  loading_modal: false,
  loading_transaction: false,
  loading_additional_doc: false,
  creating_comment: false,
  uploading_document: false,
  customers: {},
  customer: {},
  customer_transaction: {},
  customer_suspension: {},
  customer_additional_doc: [],
  customer_wallet: {},
  loading_deleted_customers: false,
  deleted_customers: {},
  // initialize other state properties
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,

  reducers: {
    SET_CUSTOMERS: (state, action) => {
      state.customers = action.payload;
    },
    SET_CUSTOMER_SINGLE: (state, action) => {
      state.customer = action.payload;
    },
    SET_CUSTOMER_SINGLE_TRANSACTION: (state, action) => {
      state.customer_transaction = action.payload;
    },
    SET_CUSTOMER_SUSPENSION_HISTORY: (state, action) => {
      state.customer_suspension = action.payload;
    },
    SET_CUSTOMER_ADDITIONAL_DOC: (state, action) => {
      state.customer_additional_doc = action.payload;
    },
    SET_CUSTOMER_WALLET: (state, action) => {
      state.customer_wallet = action.payload;
    },
    SET_DELETED_CUSTOMERS: (state, action) => {
      state.deleted_customers = action.payload;
    },
  },

  extraReducers: (builder) => {
    // pending state changes
    builder.addCase(getCustomers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCustomers.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(getCustomers.rejected, (state) => {
      state.loading = false;
      return initialState;
    });
    builder.addCase(getCustomerSingleTransaction.pending, (state) => {
      state.loading_transaction = true;
    });
    builder.addCase(getCustomerSingleTransaction.fulfilled, (state) => {
      state.loading_transaction = false;
    });
    builder.addCase(getCustomerSingleTransaction.rejected, (state) => {
      state.loading_transaction = false;
      return initialState;
    });
    builder.addCase(suspendCustomer.pending, (state) => {
      state.loading_modal = true;
    });
    builder.addCase(suspendCustomer.fulfilled, (state) => {
      state.loading_modal = false;
    });
    builder.addCase(suspendCustomer.rejected, (state) => {
      state.loading_modal = false;
      return initialState;
    });
    builder.addCase(unsuspendCustomer.pending, (state) => {
      state.loading_modal = true;
    });
    builder.addCase(unsuspendCustomer.fulfilled, (state) => {
      state.loading_modal = false;
    });
    builder.addCase(unsuspendCustomer.rejected, (state) => {
      state.loading_modal = false;
      return initialState;
    });
    builder.addCase(restoreCustomer.pending, (state) => {
      state.loading_modal = true;
    });
    builder.addCase(restoreCustomer.fulfilled, (state) => {
      state.loading_modal = false;
    });
    builder.addCase(restoreCustomer.rejected, (state) => {
      state.loading_modal = false;
      return initialState;
    });
    builder.addCase(getCustomerSuspensionHistory.pending, (state) => {
      state.loading_transaction = true;
    });
    builder.addCase(getCustomerSuspensionHistory.fulfilled, (state) => {
      state.loading_transaction = false;
    });
    builder.addCase(getCustomerSuspensionHistory.rejected, (state) => {
      state.loading_transaction = false;
      return initialState;
    });
    builder.addCase(approveCustomerKyc.pending, (state) => {
      state.loading_modal = true;
    });
    builder.addCase(approveCustomerKyc.fulfilled, (state) => {
      state.loading_modal = false;
    });
    builder.addCase(approveCustomerKyc.rejected, (state) => {
      state.loading_modal = false;
      return initialState;
    });
    builder.addCase(rejectCustomerKyc.pending, (state) => {
      state.loading_modal = true;
    });
    builder.addCase(rejectCustomerKyc.fulfilled, (state) => {
      state.loading_modal = false;
    });
    builder.addCase(rejectCustomerKyc.rejected, (state) => {
      state.loading_modal = false;
      return initialState;
    });
    builder.addCase(getCustomerAdditionalDoc.pending, (state) => {
      state.loading_additional_doc = true;
    });
    builder.addCase(getCustomerAdditionalDoc.fulfilled, (state) => {
      state.loading_additional_doc = false;
    });
    builder.addCase(getCustomerAdditionalDoc.rejected, (state) => {
      state.loading_additional_doc = false;
      return initialState;
    });
    builder.addCase(addCommentToDocument.pending, (state) => {
      state.creating_comment = true;
    });
    builder.addCase(addCommentToDocument.fulfilled, (state) => {
      state.creating_comment = false;
    });
    builder.addCase(addCommentToDocument.rejected, (state) => {
      state.creating_comment = false;
      return initialState;
    });
    builder.addCase(uploadCustomerDocument.pending, (state) => {
      state.uploading_document = true;
    });
    builder.addCase(uploadCustomerDocument.fulfilled, (state) => {
      state.uploading_document = false;
    });
    builder.addCase(uploadCustomerDocument.rejected, (state) => {
      state.uploading_document = false;
      return initialState;
    });
    builder.addCase(getCustomerWallet.pending, (state) => {
      state.loading_transaction = true;
    });
    builder.addCase(getCustomerWallet.fulfilled, (state) => {
      state.loading_transaction = false;
    });
    builder.addCase(getCustomerWallet.rejected, (state) => {
      state.loading_transaction = false;
      return initialState;
    });
     builder.addCase(getDeletedCustomers.pending, (state) => {
      state.loading_deleted_customers = true;
    });
    builder.addCase(getDeletedCustomers.fulfilled, (state) => {
      state.loading_deleted_customers = false;
    });
    builder.addCase(getDeletedCustomers.rejected, (state) => {
      state.loading_deleted_customers = false;
      return initialState;
    });
  },
});

// Action creators are generated for each case reducer function
export const {
  SET_CUSTOMERS,
  SET_CUSTOMER_SINGLE,
  SET_CUSTOMER_SINGLE_TRANSACTION,
  SET_CUSTOMER_SUSPENSION_HISTORY,
  SET_CUSTOMER_ADDITIONAL_DOC,
  SET_CUSTOMER_WALLET,
  SET_DELETED_CUSTOMERS
} = customerSlice.actions;

export default customerSlice.reducer;
